import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Router, Params } from '@angular/router';

import { FuseConfigService } from '@fuse/services/config.service';
import { fuseAnimations } from '@fuse/animations';

import { AuthService } from "../../core/auth.service";
import { CategoryExpense } from 'app/main/gastos/categories-expenses/category-expense.model';
import { CategoriesExpensesService } from 'app/main/gastos/categories-expenses/categories-expenses.service';

@Component({
    selector     : 'register-2',
    templateUrl  : './register-2.component.html',
    styleUrls    : ['./register-2.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations   : fuseAnimations,
    providers: [
        AuthService
    ]
})
export class Register2Component implements OnInit, OnDestroy
{
    registerForm: FormGroup;
    errorMessage: string = "";
    successMessage: string = "";

    // Private
    private _unsubscribeAll: Subject<any>;

    constructor(
        private router: Router,
        private _fuseConfigService: FuseConfigService,
        private _formBuilder: FormBuilder,
        private _authService: AuthService,
        private _categoryService: CategoriesExpensesService
    )
    {
        // Configure the layout
        this._fuseConfigService.config = {
            layout: {
                navbar   : {
                    hidden: true
                },
                toolbar  : {
                    hidden: true
                },
                footer   : {
                    hidden: true
                },
                sidepanel: {
                    hidden: true
                }
            }
        };

        // Set the private defaults
        this._unsubscribeAll = new Subject();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void
    {
        this.registerForm = this._formBuilder.group({
            // name           : ['', Validators.required],
            email          : ['', [Validators.required, Validators.email]],
            password       : ['', Validators.required],
            passwordConfirm: ['', [Validators.required, confirmPasswordValidator]]
        });

        // Update the validity of the 'passwordConfirm' field
        // when the 'password' field changes
        this.registerForm.get('password').valueChanges
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(() => {
                this.registerForm.get('passwordConfirm').updateValueAndValidity();
            });
    }

    /**
     * On destroy
     */
    ngOnDestroy(): void
    {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }


    tryRegister(value) {
        this._authService.doRegister(value)
            .then(res => {
                this.addCategoriesToNewUser(res.user.uid);
                let encodeValue = btoa('success_create_account');
                this.errorMessage = "";
                this.router.navigate(['auth/login', encodeValue]);
            }, err => {
                console.log(err.code);
                if (err.code == 'auth/weak-password'){
                    this.errorMessage = 'Las contraseña debe tener al menos 6 caracteres';
                } else if (err.code == 'auth/email-already-in-use') {
                    this.errorMessage = 'Este correo ya esta en uso';
                } else {
                    this.errorMessage = err.message;
                }
                
                this.successMessage = "";
            })
    }

    addCategoriesToNewUser(uid: string) {
        let categories: CategoryExpense[];

        categories = [
            new CategoryExpense({ color: '#494744', name: 'Vivienda', uid: uid}),
            new CategoryExpense({ color: '#7cdbff', name: 'Comunicaciones', uid: uid}),
            new CategoryExpense({ color: '#6b13a9', name: 'Salud', uid: uid}),
            new CategoryExpense({ color: '#551b5c', name: 'Transporte', uid: uid}),
            new CategoryExpense({ color: '#8bff61', name: 'Transporte', uid: uid}),
            new CategoryExpense({ color: '#ff68c8', name: 'Ropa y Calzado', uid: uid}),
            new CategoryExpense({ color: '#ff2207', name: 'Seguros', uid: uid}),
            new CategoryExpense({ color: '#ab7203', name: 'Higiene', uid: uid}),
            new CategoryExpense({ color: '#4d8b88', name: 'Diversión', uid: uid}),
            new CategoryExpense({ color: '#314f7e', name: 'Otros Gastos', uid: uid}),
            new CategoryExpense({ color: '#c4b40d', name: 'Educación', uid: uid}),
        ]

        categories.map((data: CategoryExpense) => {
            this._categoryService.addCategorysRegistration(data);
        })
    }
 
}



/**
 * Confirm password validator
 *
 * @param {AbstractControl} control
 * @returns {ValidationErrors | null}
 */
export const confirmPasswordValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {

    if ( !control.parent || !control )
    {
        return null;
    }

    const password = control.parent.get('password');
    const passwordConfirm = control.parent.get('passwordConfirm');

    if ( !password || !passwordConfirm )
    {
        return null;
    }

    if ( passwordConfirm.value === '' )
    {
        return null;
    }

    if ( password.value === passwordConfirm.value )
    {
        return null;
    }

    return {'passwordsNotMatching': true};
};
